import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Box, chakra, Flex, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { OtherRoomSlide } from "./components";
import { type OtherRoomInfoProps } from "./otherRoomInfo.type";

export const OtherRoomInfo = ({ currentRooms, inView }: OtherRoomInfoProps) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop, isDesktop } = MEDIAS();

    const WrapperPCPaddingRight = isLaptop ? "88px" : "256px";
    const containerPCHeight = isLaptop ? "528px" : "792px";
    const containerPCPadding = isLaptop ? "48px 24px" : "80px";

    const pensionKrNameFontSize = isLaptop ? 16 : 20;
    const pensionEngNameFontSize = isLaptop ? 32 : 48;
    return (
        <Box
            position="absolute"
            w="100%"
            top="50%"
            left="50%"
            zIndex="1"
            transform="translate(-50%, -50%)"
            paddingRight={isMobile ? "0" : WrapperPCPaddingRight}
        >
            <MotionSlideContainer
                position="relative"
                display="flex"
                justifyContent="flex-end"
                height={isMobile ? "auto" : containerPCHeight}
                w="100%"
                p={isMobile ? "24px" : containerPCPadding}
                borderRightRadius="16px"
                background="white"
                initial={{ x: "-95%" }}
                animate={inView ? { x: ["-95%", 0], transition: { duration: 0.6 } } : {}}
            >
                <Flex
                    maxW={isDesktop ? "1424px" : "1744px"}
                    w="100%"
                    h="100%"
                    display="flex"
                    flexDir="column"
                    paddingLeft={isLaptop ? "0" : "24px"}
                    rowGap={isLaptop ? "16px" : "24px"}
                >
                    <Box display={isMobile ? "none" : "block"}>
                        <Text {...FONT("notoSerif", isMobile ? 14 : pensionKrNameFontSize, 500)}>다른객실보기</Text>
                        <Text {...FONT("cormorant", isMobile ? 20 : pensionEngNameFontSize, 700, 1.2)}>
                            ROOMS PREVIEW
                        </Text>
                    </Box>
                    <OtherRoomSlide currentRooms={currentRooms} />
                </Flex>
            </MotionSlideContainer>
        </Box>
    );
};

const MotionSlideContainer = chakra(motion.div);
